import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX, FiUpload, FiEye, FiAlertCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { jobsDocument } from "../../../../redux/slices/jobsSlice";
import {
  updateProfile,
  uploadCrtDocument,
} from "../../../../redux/slices/profileSlice";

const UploadCertificateModal = ({
  show,
  onHide,
  onSave,
  applicationId,
  shouldUpdateProfile = false,
  userName,
  value,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [files, setFiles] = useState({});
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);

  const certificationOptions = [
    { id: "BLS", label: "BLS (Basic Life Support)" },
    { id: "ACLS", label: "ACLS (Advanced Cardiac Life Support)" },
    { id: "PALS", label: "PALS (Pediatric Advanced Life Support)" },
    { id: "CCRN", label: "CCRN (Critical Care Registered Nurse)" },
    { id: "NIH Stroke Scale", label: "NIH Stroke Scale" },
  ];

  useEffect(() => {
    if (!show) return;

    if (value && value.length > 0) {
      const mapped = certificationOptions.filter((opt) =>
        value.includes(opt.id),
      );

      setSelectedCertifications(mapped);
    }
  }, [show, value]);

  const handleSelect = (cert) => {
    const exists = selectedCertifications.some((c) => c.id === cert.id);

    if (exists) {
      setSelectedCertifications((prev) => prev.filter((c) => c.id !== cert.id));
    } else {
      setSelectedCertifications((prev) => [...prev, cert]);
    }

    setError("");
  };

  const handleSave = () => {
    if (!selectedCertifications.length) {
      setError("Please select at least one certification");
      return;
    }

    const selectedIds = selectedCertifications.map((c) => c.id);

    if (onSave) {
      onSave(selectedIds, files);
    }

    onHide();
  };

  const handleFileUpload = async (certId, file) => {
    if (!file) return;

    const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx", "jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const fileExt = file.name
      .split(".")
      .pop()
      .toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      setError("Only allowed file types: pdf, odt, rtf, doc, docx, jpg, jpeg, png, gif, bmp, webp");
      return;
    }

    setError("");
    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("document_type", "certification");
    formData.append("document_name", certId);
    formData.append("description", certId + " certificate");

    try {
      let uploaded;

      // ✅ CORRECT CONDITION (INSIDE FUNCTION)
      const isFirstTimeUpload =
        shouldUpdateProfile && Object.keys(files || {}).length === 0;

      if (isFirstTimeUpload) {
        // ✅ PROFILE FLOW
        const res = await dispatch(uploadCrtDocument(formData)).unwrap();
        uploaded = res?.data || res;

        const profileData = new FormData();

        if (!userName) {
          setError("Name required");
          return;
        }

        profileData.append("name", userName);

        const certArray = (selectedCertifications || [])
          .map((c) => c?.id)
          .filter((id) => typeof id === "string")
          .map((id) => id.toLowerCase());

        certArray.forEach((cert) => {
          profileData.append("certifications[]", cert);
        });

        await dispatch(updateProfile(profileData)).unwrap();
      } else {
        // ✅ APPLY FLOW
        const res = await dispatch(
          jobsDocument({
            applicationId,
            data: formData,
          }),
        ).unwrap();

        uploaded = res?.data || res;
      }

      const newFile = {
        id: uploaded.id,
        url: uploaded.file_url || uploaded.file_path,
      };

      setFiles((prev) => ({
        ...prev,
        [certId]: newFile,
      }));

      setSelectedCertifications((prev) => {
        if (prev.some((c) => c.id === certId)) return prev;
        return [...prev, certificationOptions.find((c) => c.id === certId)];
      });
    } catch (err) {
      console.error(err);
      setError("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  // const handleFileUpload = async (certId, file) => {
  //   if (!file) return;

  //   const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx"];
  //   const fileExt = file.name
  //     .split(".")
  //     .pop()
  //     .toLowerCase();

  //   if (!allowedExtensions.includes(fileExt)) {
  //     setError("Only allowed file types: pdf, odt, rtf, doc, docx");
  //     return;
  //   }

  //   setError("");
  //   setUploading(true);

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("document_type", "certification");
  //   formData.append("document_name", certId);
  //   formData.append("description", certId + " certificate");

  //   try {
  //     let uploaded;

  //     // 🔥 MAIN CONDITION
  //     if (shouldUpdateProfile) {
  //       // ✅ PROFILE UPLOAD
  //       const res = await dispatch(uploadCrtDocument(formData)).unwrap();
  //       uploaded = res?.data || res;

  //       // 🔥 PROFILE UPDATE
  //       const profileData = new FormData();

  //       if (!userName) {
  //         setError("Name required");
  //         setUploading(false);
  //         return;
  //       }

  //       profileData.append("name", userName);

  //       // 🔥 ✅ FIX: SEND ARRAY LIKE OLD FLOW
  //       const certArray = (selectedCertifications || [])
  //         .map((c) => c?.id)
  //         .filter((id) => typeof id === "string")
  //         .map((id) => id.toLowerCase());

  //       certArray.forEach((cert) => {
  //         profileData.append("certifications[]", cert);
  //       });

  //       await dispatch(updateProfile(profileData)).unwrap();
  //     } else {
  //       // ✅ APPLY FLOW
  //       const res = await dispatch(
  //         jobsDocument({
  //           applicationId,
  //           data: formData,
  //         }),
  //       ).unwrap();

  //       uploaded = res?.data || res;
  //     }

  //     const newFile = {
  //       id: uploaded.id,
  //       url: uploaded.file_url || uploaded.file_path,
  //     };

  //     // ✅ Update local state
  //     setFiles((prev) => ({
  //       ...prev,
  //       [certId]: newFile,
  //     }));

  //     // ✅ Auto select checkbox
  //     setSelectedCertifications((prev) => {
  //       if (prev.some((c) => c.id === certId)) return prev;
  //       return [...prev, certificationOptions.find((c) => c.id === certId)];
  //     });
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     setError("Upload failed. Try again.");
  //   } finally {
  //     setUploading(false);
  //   }
  // };
  // const handleFileUpload = async (certId, file) => {
  //   if (!file) return;

  //   const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx"];
  //   const fileExt = file.name
  //     .split(".")
  //     .pop()
  //     .toLowerCase();

  //   if (!allowedExtensions.includes(fileExt)) {
  //     setError("Only allowed file types: pdf, odt, rtf,  doc, docx");
  //     return;
  //   }

  //   setError("");
  //   setUploading(true);

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("document_type", "certification");
  //   formData.append("document_name", certId);
  //   formData.append("description", certId + " certificate");

  //   try {
  //     const res = await dispatch(
  //       jobsDocument({
  //         applicationId,
  //         data: formData,
  //       }),
  //     ).unwrap();

  //     const uploaded = res?.data || res;

  //     const newFile = {
  //       id: uploaded.id,
  //       url: uploaded.file_url || uploaded.file_path,
  //     };

  //     // ✅ Update local state
  //     setFiles((prev) => ({
  //       ...prev,
  //       [certId]: newFile,
  //     }));

  //     // ✅ Auto select checkbox
  //     setSelectedCertifications((prev) => {
  //       if (prev.some((c) => c.id === certId)) return prev;
  //       return [...prev, certificationOptions.find((c) => c.id === certId)];
  //     });
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     setError("Upload failed. Try again.");
  //   } finally {
  //     setUploading(false); // ✅ ALWAYS RUNS
  //   }
  // };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Certifications</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {certificationOptions.map((cert) => {
              const isSelected = selectedCertifications.some(
                (c) => c.id === cert.id,
              );
              const uploadedFile = files[cert.id];

              return (
                <div
                  key={cert.id}
                  className={`checkbox-option col-lg-6 ${
                    isSelected ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(cert)}
                >
                  <div className="contentwrap d-flex justify-content-between align-items-center">
                    <div>
                      <input type="checkbox" checked={isSelected} readOnly />
                      <label className="checkbox-label">{cert.label}</label>
                    </div>

                    {/* {isSelected && (
                      <div
                        className="d-flex gap-2"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label>
                          <FiUpload />
                          <input
                            type="file"
                            hidden
                            onChange={(e) => {
                              e.preventDefault(); // ✅ ADD THIS
                              e.stopPropagation(); // ✅ ADD THIS
                              handleFileUpload(cert.id, e.target.files[0]);
                            }}
                          />
                        </label>

                        {uploadedFile?.url && (
                          <a
                            href={uploadedFile.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FiEye />
                          </a>
                        )}
                      </div>
                    )} */}
                    {isSelected && (
                      <div
                        className="d-flex align-items-center gap-2"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {!uploadedFile ? (
                          // 🔥 Upload icon
                          <label style={{ cursor: "pointer" }}>
                            <FiUpload />

                            <input
                              type="file"
                              hidden
                              onChange={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFileUpload(cert.id, e.target.files[0]);
                              }}
                            />
                          </label>
                        ) : (
                          // ✅ Uploaded state
                          <div className="d-flex align-items-center gap-1 text-success">
                            ✔ <span style={{ fontSize: "12px" }}>Uploaded</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {error && (
            <div
              className="alert alert-danger mt-3 d-flex align-items-center"
              role="alert"
              style={{ fontSize: "14px", padding: "10px 15px" }}
            >
              <FiAlertCircle
                className="me-2"
                size={18}
                style={{ flexShrink: 0 }}
              />
              <div>{error}</div>
            </div>
          )}

          <div className="text-center mt-4">
            <Button onClick={handleSave} disabled={uploading}>
              {uploading ? "Uploading..." : "Save"}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UploadCertificateModal;
